'use strict';

(function () {
    'use strict';

    angular.module('zp.nav', []);
})();